let cached = null;
const PREVIEW_ENVS = ['test'];

function parseHost(hostname) {
  const host = hostname || '';
  const parts = host.split('.').filter(Boolean);
  const subdomain = parts.length > 2 ? parts[0] : parts.length === 2 ? parts[0] : '';
  const domain = parts.length > 1 ? parts.slice(-2).join('.') : host;

  let env = 'unknown';
  if (host === 'scoring.local' || host === 'localhost' || host.endsWith('.local')) {
    env = 'local';
  } else if (host === 'test.slackline-tjs.com' || subdomain === 'test') {
    env = 'test';
  } else if (host === 'app.slackline-tjs.com' || subdomain === 'app') {
    env = 'prod';
  }

  return { host, domain, subdomain, env };
}

export function getHostContext() {
  if (cached) return cached;
  const host = typeof window !== 'undefined' ? window.location.hostname : '';
  cached = parseHost(host);
  return cached;
}

export function isLocalEnv() {
  return getHostContext().env === 'local';
}

export function isTestEnv() {
  return getHostContext().env === 'test';
}

export function isProdEnv() {
  return getHostContext().env === 'prod';
}

export function isPreviewEnv(envOverride) {
  const env = envOverride || getHostContext().env;
  return PREVIEW_ENVS.includes(env);
}
